export const RealEstates = {
    1: 'REAL_ESTATE_1',
    2: 'REAL_ESTATE_2'
}